export const LOCAL_SERVER_PORT = 4000;

// user
export const USER = 'USER';
export const ARTIST = 'ARTIST';
export const ADMIN = 'ADMIN';
export const MIN_PASSWORD_LENGTH = 5;
export const MAX_PASSWORD_LENGTH = 60;
export const MAX_NAME_LENGTH = 40;
export const MIN_USERNAME_LENGTH = 3;
export const MAX_USERNAME_LENGTH = 30;
export const MAX_ABOUT_ME_LENGTH = 5000;
export const MAX_CITY_LENGTH = 30;
export const RESET_TOKEN_LIFETIME = 3600; // password reset token expires in 1 hour
export const RESET_TOKEN_LENGTH = 48;
export const MIN_ARTIST_AGE = 18;
export const MAX_PENDING_ORDERS = 3;
export const DEFAULT_ARTIST_FEE = 0; // 0%
export const MIN_DISCOUNT_PERCENTAGE = 0.01; // 1%
export const MAX_DISCOUNT_PERCENTAGE = 0.99; // 99%
export const MIN_DISCOUNT_FIXED = 1;
export const MAX_DISCOUNT_FIXED = 9999;
export const MAX_PERSONALIZATION_IMAGES_IN_CART = 2;

// Product
export const MAX_SLUG_LENGTH = 40;
export const MIN_PRODUCT_TITLE_LENGTH = 15;
export const MAX_PRODUCT_TITLE_LENGTH = 100;
export const MAX_PRODUCT_DESCRIPTION_LENGTH = 8000;
export const MAX_PERSONALIZATION_TEXT_LENGTH = 2000;
export const MIN_PRODUCT_PRICE = 5;
export const MAX_PRODUCT_PRICE = 10000;
export const MAX_SHIPPING_COST = 100;
export const MAX_PRODUCT_STOCK = 100;
export const MAX_PRODUCT_IMAGES = 8;
export const MIN_PRODUCT_IMAGES = 2;
export const MAX_PENDING_PRODUCTS = 8;
export const MAX_FREEMIUM_PRODUCTS = 20;
export const MAX_CUSTOMS_FOR_USER = 2;
export const MAX_DELIVERY_DAYS = 31;

// Courier
export const Courier = {
  FanCourier: 'FAN Courier',
  Sameday: 'Sameday',
  Cargus: 'Cargus',
  DPD: 'DPD',
  GLS: 'GLS',
  Post: 'Poștă',
  FedEx: 'FedEx',
  Other: 'Altul',
};

export const CourierLink = {
  FanCourier: (awb) =>
    `https://www.fancourier.ro/awb-tracking/?tracking=${awb}`,
  Sameday: (awb) =>
    `https://www.cargus.ro/personal/urmareste-coletul/?tracking_number=${awb}&Urm%C4%83re%C8%99te=Urm%C4%83re%C8%99te`,
  Cargus: (awb) => `https://sameday.ro/#awb=${awb}`,
  DPD: (awb) => `https://tracking.dpd.ro/?shipmentNumber=${awb}`,
  GLS: (awb) => `https://gls-group.com/RO/ro/urmarire-colet`,
  Post: (awb) => `https://www.posta-romana.ro/track-trace.html`,
  FedEx: (awb) => `https://www.fedex.com/fedextrack/?trknbr=${awb}`,
  Other: (awb) => `${awb}`,
};

// Category
export const MIN_CATEGORY_LENGTH = 3;
export const MAX_CATEGORY_LENGTH = 30;

// Photo
export const MAX_PHOTO_MB_SIZE = 10;
export const MAX_PHOTO_SIZE = MAX_PHOTO_MB_SIZE * 1024 * 1024;

// Image resizing (with enlargement by default)
export const RESIZE_AVATAR_SMALL = { width: 60, height: 60, quality: 100 };
export const RESIZE_AVATAR_LARGE = { width: 150, height: 150, quality: 100 };
export const RESIZE_PRODUCT_IMAGE = {
  width: 1024,
  height: 1024,
};
export const RESIZE_PRODUCT_THUMBNAIL = {
  width: 300,
  height: 300,
  withoutEnlargement: true,
};
export const RESIZE_CHAT_IMAGE = {
  width: 600,
  height: 600,
  fit: 'inside',
  withoutEnlargement: true,
};
export const RESIZE_REVIEW = {
  width: 600,
  height: 600,
  fit: 'inside',
  withoutEnlargement: true,
};

// Reviews
export const MAX_REVIEW_IMAGES = 5;
export const MAX_REVIEW_LENGTH = 5000;

// Orders
export const MIN_ORDER_TOTAL = 2; // Stripe needs at least 2.00 lei

// Types
export const Category = {
  Deco: 'Decor',
  Paintings: 'Tablouri',
  Jewelry: 'Bijuterii',
  Accessories: 'Accesorii',
  Toys: 'Jucării',
  Candles: 'Lumânări',
  Clothes: 'Haine',
  Sneakers: 'Sneakers',
  Other: 'Diverse',
};

export const OrderStatus = {
  AwaitingPayment: 'Se așteaptă plata',
  AwaitingConfirmation: 'Așteaptă confirmare',
  Processing: 'În procesare',
  Shipped: 'Expediată',
  Cancelled: 'Anulată',
  Finalized: 'Finalizată',
};

export const Status = {
  Approved: 'Approved',
  Pending: 'Pending',
  Rejected: 'Rejected',
  Disabled: 'Disabled',
};

export const PaymentMethod = {
  Online: 'Online', // Stripe
  CashOnDelivery: 'Cash on delivery',
};

// Functions
export function getFirstName(fullName) {
  return fullName.split(' ')[0].split('-')[0];
}

export function isInstagramUsername(str) {
  if (!str || str.length > 30) return false;
  if (str[str.length - 1] === '.') return false;
  return /^[a-zA-Z0-9._]+$/.test(str);
}

/* 
Display names can only have: 
- Letters with romanian diacritics
- Numbers
- Dots
- Underscores
- Spaces
- Dashes -
*/
export function isValidDisplayName(str) {
  if (typeof str !== 'string') return false;
  if (
    !str ||
    str.length < MIN_USERNAME_LENGTH ||
    str.length > MAX_USERNAME_LENGTH
  )
    return false;
  if (str[str.length - 1] === '.') return false;
  const regex = /^[a-zA-ZăĂîÎâÂșȘțȚ0-9_.\s-]+$/;
  return regex.test(str);
}

export function isTempEmail(email) {
  return (
    email && email.startsWith('contact+') && email.endsWith('@customstudio.ro')
  );
}

export function areSelectedOptionsEqual(a, b) {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; ++i) {
    if (a[i].variationTitle !== b[i].variationTitle) return false;
    if (a[i].value !== b[i].value) return false;
  }
  return true;
}

export function findSimilarCartItem(
  cart,
  productId,
  selectedOptions,
  personalizationText,
  personalizationImagesCount
) {
  if (personalizationImagesCount > 0) {
    return null;
  }

  for (const subOrder of cart.subOrders) {
    for (const cartItem of subOrder.cartItems) {
      if (cartItem.personalizationImages?.length) {
        continue;
      }
      if (
        String(cartItem.product._id) === String(productId) &&
        cartItem.personalizationText === personalizationText &&
        areSelectedOptionsEqual(cartItem.selectedOptions, selectedOptions)
      ) {
        return cartItem;
      }
    }
  }

  return null;
}

export async function addProductToCart(
  cart,
  product,
  selectedOptions,
  personalizationText,
  personalizationImageFiles,
  processPersonalizationImages
) {
  // verify all variations have been submitted
  if (selectedOptions.length !== product.variations.length) {
    throw Error('Alege dintre opțiuni.');
  }

  selectedOptions = selectedOptions.map((selectedOption) => {
    const variation = product.variations.find(
      (v) => String(v._id) === selectedOption.variationId
    );
    const option = variation?.options.find(
      (o) => String(o._id) === selectedOption.optionId
    );
    if (!option) {
      throw Error('Alege dintre opțiuni.');
    }
    return {
      ...option,
      variationTitle: variation.title,
    };
  });

  const sameItem = findSimilarCartItem(
    cart,
    product._id,
    selectedOptions,
    personalizationText,
    personalizationImageFiles.length
  );

  if (sameItem) {
    sameItem.quantity++;
  } else {
    // add a new item
    const newCartItem = {
      id: Math.random().toString(36).substring(2), // only used by the client
      product,
      quantity: 1,
      selectedOptions,
      personalizationText,
      personalizationImages: await processPersonalizationImages(
        personalizationImageFiles
      ),
    };

    // check if the cart already has products from this artist
    const artistEntry = cart.subOrders.find(
      (so) => String(so.artist._id) === String(product.artist._id)
    );

    if (artistEntry) {
      artistEntry.cartItems.push(newCartItem);
    } else {
      cart.subOrders.push({
        artist: product.artist,
        cartItems: [newCartItem],
      });
    }
  }
}

export function updateCartPrices(cart) {
  for (const subOrder of cart.subOrders) {
    subOrder.productsPrice = 0;
    subOrder.discount = 0;
    subOrder.shippingCost = 0;

    for (const cartItem of subOrder.cartItems) {
      const { product } = cartItem;
      cartItem.selectedOptionsPriceChange = cartItem.selectedOptions.reduce(
        (acc, selectedOption) => (acc += selectedOption.priceChange),
        0
      );
      subOrder.productsPrice +=
        (product.price + cartItem.selectedOptionsPriceChange) *
        cartItem.quantity;
      subOrder.shippingCost = Math.max(
        subOrder.shippingCost,
        product.shippingCost
      );
    }

    // apply discount code
    if (subOrder.discountCode) {
      const discountCode = subOrder.discountCode;
      if (discountCode.percentage) {
        subOrder.discount = discountCode.percentage * subOrder.productsPrice;
      } else if (discountCode.fixed) {
        subOrder.discount = discountCode.fixed;
      }
    }

    subOrder.total = Math.max(
      0,
      subOrder.productsPrice + subOrder.shippingCost - subOrder.discount
    );
  }

  // compute overall costs
  cart.productsPrice = 0;
  cart.discount = 0;
  cart.shippingCost = 0;
  cart.total = 0;

  for (const subOrder of cart.subOrders) {
    cart.productsPrice += subOrder.productsPrice;
    cart.discount += subOrder.discount;
    cart.shippingCost += subOrder.shippingCost;
    cart.total += subOrder.total;
  }
}
